export class StarBreathingFollower extends Phaser.Events.EventEmitter {
  constructor({ path, target, offset, speed }) {
    super();
    this._path = path.map((p) => ({ ...p, x: offset.x + p.x, y: offset.y + p.y }));
    this._target = target;
    this._speed = speed || 500;

    this._path.shift();
    this._target.setPosition(this._path[0].x, this._path[0].y);

    this._followToStar = false;
    this._previousPoint = false;
    this._pointsVisited = 0;
    this._starsReached = 0;
  }

  set speed(value) {
    this._speed = value;
  }

  get pathComplete() {
    return this._path.length === 0;
  }

  get starReached() {
    return this._previousPoint.star;
  }

  clearCurrentStarPoint() {
    this._previousPoint = false;
  }

  get pathIndex() {
    return this._pointsVisited;
  }

  get currentPoint() {
    return this._previousPoint;
  }

  update(delta) {
    if (this._path.length === 0) return;
    let deltaDistance = (delta * this._speed) / 1000;
    while (deltaDistance > 0) {
      const destination = this._path[0];
      const distance = Phaser.Math.Distance.BetweenPoints(this._target, destination);
      if (distance > deltaDistance) {
        const angle = Phaser.Math.Angle.BetweenPoints(this._target, destination);
        this._target.x = this._target.x + deltaDistance * Math.cos(angle);
        this._target.y = this._target.y + deltaDistance * Math.sin(angle);
        deltaDistance = 0;
      } else {
        deltaDistance -= distance;
        this._target.x = this._path[0].x;
        this._target.y = this._path[0].y;
        this._previousPoint = { ...this._path[0] };

        const point = this._path[0];
        this._path.shift();
        this._pointsVisited++;
        if (this.pathComplete) break;
        else if (point.star) {
          this._starsReached++;
          this.emit('star_reached', this._starsReached);
        }
      }
    }
  }
}
